import { GetServerSideProps } from "next"
import { AppInterface } from "types/types"
import clientPromise from "utils/backend/mongodb"
import ProfileCard from "views/profile/ProfileCard"

interface Props {
  userId: string
  userData: {
    photoURL: string
    displayName: string
    bio: string
    email: string
  }
  userApps: AppInterface[]
}

const ProfilePage = (props: Props) => {
  return <ProfileCard {...props} />
}

export default ProfilePage

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const client = await clientPromise
  const db = client.db(process.env.NEXT_PUBLIC_MONGODB_DB)
  const userId = params?.id
  const [user, apps] = await Promise.all([
    db.collection("users").findOne({ uid: userId }),
    db
      .collection("apps")
      .find({ "submitters.uid": userId })
      .sort({ lastModified: -1 })
      .limit(20)
      .toArray(),
  ])

  const userApps = JSON.parse(JSON.stringify(apps))

  return {
    props: {
      userId,
      userApps,
      userData: {
        photoURL: user?.photoURL || null,
        displayName: user?.displayName || null,
        bio: user?.bio || null,
        email: user?.email || null,
      },
    },
  }
}
